import { RefillStep, RefillStyle } from 'app/dataTypes/acquiring/settings'

export const getIsReturnLinkAvailable = (
  refillStep: RefillStep | null,
  refillStyle: RefillStyle | null,
) => {
  return refillStyle === RefillStyle.Recurrent
    ? refillStep === RefillStep.Step5
    : refillStep === RefillStep.Step4
}
